<div #chart style="width: 100%; height: calc(100% - 27px); position: relative;" class="multi-line-chart-container"></div>

@if (scrollableLegend()) {
<div class="list-button legend-scroller">
  @if (legendOverflows()) {
  <button type="button" class="legend-nav-btn" [disabled]="!canScrollLegendPrev()"
    [attr.aria-label]="'common.scrollLeft' | transloco" (click)="scrollLegend(-1)">
    <i class="ph ph-caret-left"></i>
  </button>
  }
  <ul class="graph-point legend-track" #legendTrack (wheel)="onLegendWheel($event)">
    @for (item of legend(); track item) {
    <li #legendItem [title]="item.legend || ''">
        <div class="legend-color" [style.backgroundColor]="item.color || 'gray'"></div>{{item.legend || ''}}
    </li>
    }
  </ul>
  @if (legendOverflows()) {
  <button type="button" class="legend-nav-btn" [disabled]="!canScrollLegendNext()"
    [attr.aria-label]="'common.scrollRight' | transloco" (click)="scrollLegend(1)">
    <i class="ph ph-caret-right"></i>
  </button>
  }
</div>
} @else {
<div class="list-button">
  <ul class="graph-point">
    @for (item of legend(); track item) {
    <li>
        <div class="legend-color" [style.backgroundColor]="item?.color || 'gray'"></div>{{item?.legend || ''}}
    </li>
    }
  </ul>
</div>
}